import ToggleIndexView from './ToggleIndexView';

export default ToggleIndexView;
